<template>
  <div style="display:flex;margin-bottom: 1px;justify-content: space-between;padding:10px 10px 0 10px;">
    <el-tabs class="main-table-tabs" v-model="selectedTab" @tab-click="handleClick">
      <el-tab-pane v-for="tab in dept_tabs.filter(t=>!t.hide)" :label="tab.label" :name="tab.label"></el-tab-pane>
    </el-tabs>
    <div style="height:32px;display: flex;">
      <el-input size="small" v-model.trim="searchInput" placeholder="搜索商机、客户名称、客户经理姓名、售前负责人姓名">
        <el-button slot="append" type="small" icon="el-icon-search" @click="searchBlur"></el-button>
      </el-input>
      <el-button style="margin-left:10px;" size="small" @click="$emit('export')">导出CSV文件</el-button>
      <el-button type="primary" size="small" @click="$emit('addBussiness')">添加商机线索</el-button>
    </div>

  </div>
</template>

<script>
export default {
  name: "MainTableTool",
  props:['value','dept_tabs'],
  data(){
    return {
      selectedTab:"",
      searchInput:"",
      lastSearchInput:""
    }
  },
  watch:{
    value(newVal){
      this.selectedTab = newVal
    }
  },
  mounted() {
    this.selectedTab = this.value
  },
  methods:{
    searchBlur(){
      if(this.lastSearchInput!==this.searchInput){
        this.lastSearchInput = this.searchInput
        this.$emit("searchChange",this.searchInput)
      }
    },
    handleClick() {
      this.$emit("input",this.selectedTab)
    }
  }
}
</script>

<style lang="scss">
.main-table-tabs{
  .el-tabs__header{
    margin:0;
  }
  .el-tabs__item.is-top{
    height: 40px !important;
    line-height: 40px !important;
  }
  .el-tabs__nav-scroll{
    height:40px !important;
  }

  .el-tabs__nav-wrap::after {
    position: static !important;
  }
  .el-tabs__item{
    min-width: 50px !important;
    padding-left: 0px !important;
  }
}


input {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

</style>
